import axios from 'axios'

const admin = { 
  getAdminSettings: () => axios.get( 
    `${process.env.REACT_APP_API_URL}admin/AdminSettings` 
  ).then(res => res.data),
  postAdminSettings:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/AdminSettings`, data
  ).then( res => res.data ),
  getAdvisors: () => axios.get( 
    `${process.env.REACT_APP_API_URL}admin/Advisors` 
  ).then(res => res.data),
  getAdvisor: (email) => axios.get(
    `${process.env.REACT_APP_API_URL}admin/Advisor?email=${email}`
  ).then( res => res.data ),
  getUsers: () => axios.get(
    `${process.env.REACT_APP_API_URL}admin/Users`
  ).then( res => res.data ),
  getAdvisorUsers: (email) => axios.get(
    `${process.env.REACT_APP_API_URL}admin/Users?advisorEmail=${email}`
  ).then( res => res.data ),
  getTaxes: () => axios.get(
    `${process.env.REACT_APP_API_URL}admin/TaxTable`
  ).then( res => res.data ),
  postTax:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/TaxTable`, data
  ).then( res => res.data ),
  getSystemMessage: () => axios.get(
    `${process.env.REACT_APP_API_URL}admin/SystemMessage`
  ).then( res => res.data ),
  postSystemMessage:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/SystemMessage`, data
  ).then( res => res.data ),
  getCPPSettings: () => axios.get(
    `${process.env.REACT_APP_API_URL}admin/CPPSettings`
  ).then( res => res.data ),
  postCPPSettings:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/CPPSettings`, data
  ).then( res => res.data ),
  getOASSettings: () => axios.get(
    `${process.env.REACT_APP_API_URL}admin/OASSettings`
  ).then( res => res.data ),
  postOASSettings:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/OASSettings`, data
  ).then( res => res.data ),
  getFEDSettings: (type) => axios.get(
    `${process.env.REACT_APP_API_URL}admin/FEDSettings?type=${type}`
  ).then( res => res.data ),
  postFEDSettings:  (type, data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/FEDSettings?type=${type}`, data
  ).then( res => res.data ),
  postOtherSettings:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/OtherSettings`, data
  ).then( res => res.data ),
  getProvSettings: (prov) => axios.get(
    `${process.env.REACT_APP_API_URL}admin/ProvSettings?prov=${prov}`
  ).then( res => res.data ),
  postProvSettings:  (prov, data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/ProvSettings?prov=${prov}`, data
  ).then( res => res.data ),
  getCGRSettings: () => axios.get(
    `${process.env.REACT_APP_API_URL}admin/CapitalGainRates`
  ).then( res => res.data ),
  postCGRSettings:  (data) => axios.post(
    `${process.env.REACT_APP_API_URL}admin/CapitalGainRates`, data
  ).then( res => res.data ),
}
export default admin